import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-connectus',
  templateUrl: './connectus.component.html',
  styleUrls: ['./connectus.component.css']
})
export class ConnectusComponent implements OnInit {
  modal: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
